import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import "./HomeEmployees.scss";
import { Logout } from "@mui/icons-material";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import PasswordIcon from "@mui/icons-material/Password";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import Dashboard from "../Dashboard/Dashboard";
import Riskmap from "../Riskmap/Riskmap";
import Profile from "../Profile/Profile";
import Support from "../Support/Support";
import Wellness from "../Wellness/Wellness";
import RepairVehicle from "../RepairVehicle/RepairVehicle";
import DoctorOnline from "../DoctorOnline/DoctorOnline";
import Community from "../Community/Community";
import ClaimAssistant from "../ClaimAssistant/ClaimAssistant";
import PolicyWallet from "../PolicyWallet/PolicyWallet";
import MyDocument from "../MyDocument/MyDocument";
import MarketplaceRouter from "../Marketplace/MarketplaceRouter";
import AiChatAssistant from "../Components/AiChatAssistant/AiChatAssistant";

function HomeEmployees() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMarketplace = location.pathname.startsWith("/home-employee/marketplace");
  const [darkThemeStatus, setDarkThemeStatus] = React.useState(false);
  // User Dropdown
  const [userDropdown, setUserDropdown] = React.useState<null | HTMLElement>(
    null
  );
  const [notificationDropdown, setNotificationDropdown] =
    React.useState<null | HTMLElement>(null);

  const open = Boolean(userDropdown);
  const openNotification = Boolean(notificationDropdown);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setUserDropdown(event.currentTarget);
  };
  const notificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationDropdown(event.currentTarget);
  };
  const nofiticationClose = () => {
    setNotificationDropdown(null);
  };
  const handleClose = () => {
    setUserDropdown(null);
  };

  const [isMenuActive, setIsMenuActive] = useState(false);
  const toggleExpand = () => {
    setIsMenuActive(!isMenuActive);
  };

  const [activePage, setActivePage] = useState<string>("Dashboard");
  const changePage = (page: any) => {
    if (isMarketplace) {
      navigate("/home-employee");
    }
    setActivePage(page);
  };

  const openMarketplace = () => {
    setActivePage("");
    navigate("/home-employee/marketplace");
  };

  return (
    <Box className="employeeWrapper">
      <Grid container spacing={3}>
        <Grid xs>
          <img src="/images/benfit-care.svg" height={"40px"} alt="Benefit Care" />
        </Grid>
        <Grid xs>
          <Box className="navLinks">
            <Tooltip title="Task Management">
              <Link>
                <AssignmentTurnedInOutlinedIcon />
              </Link>
            </Tooltip>
            <Tooltip title="Custom Settings">
              <Link>
                <TuneOutlinedIcon />
              </Link>
            </Tooltip>
            <Tooltip title="Theme Change">
              <Link
                onClick={() => {
                  // add_dark_theme(!darkThemeStatus);
                  // setDarkThemeStatus(!darkThemeStatus);
                }}
                className="themeToggle"
              >
                {darkThemeStatus == false ? (
                  <LightModeIcon />
                ) : (
                  <NightsStayIcon />
                )}
              </Link>
            </Tooltip>

            {/* Notification */}
            <Box className="notificationDropdown">
              <Tooltip title="Notifications">
                <IconButton
                  onClick={notificationClick}
                  size="small"
                  aria-controls={
                    openNotification ? "notifiction-menu" : undefined
                  }
                  aria-haspopup="true"
                  aria-expanded={openNotification ? "true" : undefined}
                >
                  <NotificationsNoneRoundedIcon />
                </IconButton>
              </Tooltip>

              <Menu
                anchorEl={notificationDropdown}
                id="notifiction-menu"
                open={openNotification}
                onClose={nofiticationClose}
                onClick={nofiticationClose}
                className="notificationMenu"
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                    borderRadius: "8px",
                    mt: 1,
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "#EDF1FE",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="listMenu">
                  <div className="title">
                    Notifications <Link>View All</Link>
                  </div>
                  <li>
                    <h5>Health Insurance</h5>
                    <p>You have been given a health insurance policy.</p>
                  </li>
                  <li>
                    <h5>Claim Request</h5>
                    <p>Your cashless claim request has been approved.</p>
                  </li>
                  <li>
                    <h5>Health Insurance</h5>
                    <p>You have been given a health insurance policy.</p>
                  </li>
                  <li>
                    <h5>Claim Request</h5>
                    <p>Your cashless claim request has been approved.</p>
                  </li>
                  <li>
                    <h5>Health Insurance</h5>
                    <p>You have been given a health insurance policy.</p>
                  </li>
                  <li>
                    <h5>Claim Request</h5>
                    <p>Your cashless claim request has been approved.</p>
                  </li>
                </Box>
              </Menu>
            </Box>

            <Box className="userDropdown">
              <Tooltip title="User Account">
                <IconButton
                  onClick={handleClick}
                  size="small"
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <img src="/images/transparent_face_img.svg" alt="User profile" />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={userDropdown}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                    borderRadius: "8px",
                    mt: 1,
                    "& .MuiAvatar-root": {
                      width: 22,
                      height: 22,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleClose}>
                  <Avatar />
                  Rahul Raghuvanshi
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <PasswordIcon fontSize="small" />
                  </ListItemIcon>
                  Change Password
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid className="menuCol" xs>
          <Box className={isMenuActive ? "menuList expand" : "menuList"}>
            <Link className="expandView" onClick={toggleExpand}>
              {isMenuActive ? (
                <KeyboardArrowLeftRoundedIcon />
              ) : (
                <KeyboardArrowRightRoundedIcon />
              )}
            </Link>
            <Tooltip title="Dashboard" placement="bottom">
              <Button
                className={
                  activePage === "Dashboard" && !isMarketplace
                    ? "dashboard active"
                    : "dashboard"
                }
                onClick={() => changePage("Dashboard")}
              >
                Dashboard
              </Button>
            </Tooltip>

            <Tooltip title="Policy Wallet" placement="bottom">
              <Button
                className={
                  activePage === "policywallet"
                    ? "policywallet active"
                    : "policywallet"
                }
                onClick={() => changePage("policywallet")}
              >
                Policy Wallet
              </Button>
            </Tooltip>

            <Tooltip title="Riskmap" placement="bottom">
              <Button
                className={
                  activePage === "riskmap" ? "riskmap active" : "riskmap"
                }
                onClick={() => changePage("riskmap")}
              >
                Riskmap
              </Button>
            </Tooltip>

            <Tooltip title="Profile" placement="bottom">
              <Button
                className={
                  activePage === "userprofile"
                    ? "userprofile active"
                    : "userprofile"
                }
                onClick={() => changePage("userprofile")}
              >
                Profile
              </Button>
            </Tooltip>
            <Tooltip title="My Document" placement="bottom">
              <Button
                className={
                  activePage === "mydocument"
                    ? "mydocument active"
                    : "mydocument"
                }
                onClick={() => changePage("mydocument")}
              >
                My Document
              </Button>
            </Tooltip>

            <Tooltip title="Your Request" placement="bottom">
              <Button
                className={
                  activePage === "Claim"
                    ? "claimassistant active"
                    : "claimassistant"
                }
                onClick={() => changePage("Claim")}
              >
                Community
              </Button>
            </Tooltip>

            <Tooltip title="Community" placement="bottom">
              <Button
                className={
                  activePage === "Community" ? "community active" : "community"
                }
                onClick={() => changePage("Community")}
              >
                Community
              </Button>
            </Tooltip>

            <Tooltip title="Support" placement="bottom">
              <Button
                className={
                  activePage === "support" ? " support active" : "support"
                }
                onClick={() => changePage("support")}
              >
                Support
              </Button>
            </Tooltip>

            <Tooltip title="Marketplace" placement="bottom">
              <Button
                className={isMarketplace ? "marketplace active" : "marketplace"}
                onClick={openMarketplace}
              >
                Marketplace
              </Button>
            </Tooltip>

            <Tooltip title="Wellness" placement="bottom">
              <Button
                className={
                  activePage === "Wellness" ? "wellness active" : "wellness"
                }
                onClick={() => changePage("Wellness")}
              >
                Wellness
              </Button>
            </Tooltip>

            <Tooltip title="Doctor Online" placement="bottom">
              <Button
                className={
                  activePage === "DoctorOnline"
                    ? "doctoronline active"
                    : "doctoronline"
                }
                onClick={() => changePage("DoctorOnline")}
              >
                Doctor Online
              </Button>
            </Tooltip>

            <Tooltip title="Repair Vehicle" placement="bottom">
              <Button
                className={
                  activePage === "Repair"
                    ? "repairvehicle active"
                    : "repairvehicle"
                }
                onClick={() => changePage("Repair")}
              >
                Repair Vehicle
              </Button>
            </Tooltip>
          </Box>
        </Grid>
        {isMarketplace ? <MarketplaceRouter /> : null}
        {!isMarketplace && activePage == "Dashboard" ? <Dashboard /> : null}
        {!isMarketplace && activePage == "riskmap" ? <Riskmap /> : null}
        {!isMarketplace && activePage == "policywallet" ? <PolicyWallet /> : null}
        {!isMarketplace && activePage == "userprofile" ? <Profile /> : null}
        {!isMarketplace && activePage == "mydocument" ? <MyDocument /> : null}
        {!isMarketplace && activePage == "support" ? <Support /> : null}
        {!isMarketplace && activePage == "Wellness" ? <Wellness /> : null}
        {!isMarketplace && activePage == "Repair" ? <RepairVehicle /> : null}
        {!isMarketplace && activePage == "DoctorOnline" ? <DoctorOnline /> : null}
        {!isMarketplace && activePage == "Community" ? <Community /> : null}
        {!isMarketplace && activePage == "Claim" ? <ClaimAssistant /> : null}
      </Grid>
      <AiChatAssistant />
    </Box>
  );
}

export default HomeEmployees;
